/**
 * 首页模块接口列表
 */
import base from "./base"; // 导入接口域名列表
import axios from "./http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
import axiosc from "axios";

const home = {
  S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  },
  guid() {
    return (this.S4() + this.S4() +'-' + this.S4() +'-' + this.S4() +'-' + this.S4() +'-' + this.S4() + this.S4() + this.S4())
  },
  // 首页列表
  bookMenuList() {
    var uuid = this.guid();
    return axios.get(`/mbs/api/shop?uuid=${uuid}`);
  },
  soldMachineList(shopid) {
   
    if(shopid){
      return axios.post(`/mbs/api/item?Shopid=${shopid}`);
    }else{
      return axios.post(`/mbs/api/item`);
    }
  },
    // 新闻详情,演示
    soldMachineListDetail (id) {
      var uuid = this.guid();
      return axios.get(`/mbs/api/item/${id}?uuid=${uuid}`);
  },
  soldMachineSearchList(Keyword) {
      
    if(Keyword){
      return axios.post(`/mbs/api/item?Keyword=${Keyword}`);
    }else{
      return axios.post(`/mbs/api/item`);
    }
  },
  soldMachineShopCode(shopCode){
    var uuid = this.guid();
    return axios.get(`/mbs/api/shop/${shopCode}?uuid=${uuid}`);
  }
 
};

export default home;
